import { platform } from 'constants'
import React, { useMemo } from 'react'

import { Box } from 'widgets/Box'

import { ActionIcon } from '../../PostCard/subcomponents'

type PostMenuProps = {
  mode: 'dark' | 'light'
  isOwner: boolean
  handlePostOwnerMenu: () => void
  handlePostViewerMenu: () => void
  style?: any | undefined
}

export const PostMenu = ({
  mode,
  isOwner,
  handlePostOwnerMenu,
  handlePostViewerMenu,
  style,
}: PostMenuProps) => {
  const color = useMemo(() => (mode === 'dark' ? 'text' : 'white'), [mode])

  return (
    <Box align='flex-end' padding={{ top: !platform.IS_WEB ? 16 : undefined }} style={style}>
      {isOwner && (
        <ActionIcon
          icon='options-menu'
          color={color}
          label=''
          action={handlePostOwnerMenu}
          iconSize={20}
        />
      )}
      {!isOwner && (
        <ActionIcon
          icon='options-menu'
          color={color}
          label=''
          action={handlePostViewerMenu}
          iconSize={20}
        />
      )}
    </Box>
  )
}
